import '../icon'
import '../mobile'

var DEFAULT_ICON_COLOUR = "black";
var DEFAULT_BACKGROUND_COLOUR = "#ffffff";

export default angular.module('syHover', ['syIcon', 'syMobile'])
    /**
     * @ngdoc directive
     * @name hover.directive:syHover
     * @description
     * Handles the hover event of the attached element. When the element is hovered or
     * unhovered, any child elements that have the syHoverItem specified will change
     * their background image url.
     */
    // @ngInject
    .directive('syHover', ['$window', '$document', 'IconService', 'MobileService', function ($window, $document, IconService, MobileService) {
        return {
            scope: true,
            restrict: 'A',
            controller: [function () {
                var controller = this;

                // Initialise variables
                this.state = 'initial'; // Possible states are initial, hover and locked
                this.items = [];
                this.width = 0;
                this.windowFocus = true;

                // Reload the background image of all items
                this.reloadBackground = function () {
                    for (var i = 0; i < controller.items.length; i++) {
                        var item = controller.items[i];
                        if (item && item.element && item.icon && item.icon !== '') {
                            var iconColour = DEFAULT_ICON_COLOUR;
                            switch (controller.state) {
                                case 'initial':
                                    iconColour = item.initial;
                                    break;
                                case 'hover':
                                case 'locked':
                                    if (controller.width < 610) {
                                        iconColour = item.hover1;
                                    }
                                    else {
                                        iconColour = item.hover2;
                                    }
                                    break;
                            }
                            item.element.css('background-image', 'url("' + IconService.generateSVGUrl(item.icon, iconColour) + '")')
                        }
                    }
                };
            }],
            link: function ($scope, $element, attrs, controller) {
                controller.width = $window.innerWidth;

                // Set up the directive differently depending on if mobile or not
                if (MobileService.mobileCheck()) {
                    if (!MobileService.appleCheck()) {
                        $element.on('focus touchstart', function () {
                            controller.state = 'hover';
                            controller.reloadBackground();
                        });
                        $element.on('blur', function () {
                            controller.state = 'initial';
                            controller.reloadBackground();
                        });
                    }
                    else {
                        $element.on('touchstart', function () {
                            controller.state = 'hover';
                            controller.reloadBackground();
                        });
                        $element.on('touchend', function () {
                            controller.state = 'initial';
                            controller.reloadBackground();
                        });
                    }
                }
                else {
                    // Bind hover events
                    $element.on('mouseenter', function () {
                        if (controller.state !== 'locked') {
                            controller.state = 'hover';
                            controller.reloadBackground();
                        }
                    });
                    $element.on('mouseleave', function () {
                        if (controller.state !== 'locked') {
                            controller.state = 'initial';
                            controller.reloadBackground();
                        }
                    });

                    // Bind window events
                    angular.element($window).bind('resize', function () {
                        $scope.$apply(function () {
                            controller.width = $window.innerWidth;
                            controller.reloadBackground();
                        });
                    });
                    angular.element($window).bind('focus', function () {
                        $scope.$apply(function () {
                            controller.windowFocus = true;
                        });
                    });
                    angular.element($window).bind('blur', function () {
                        $scope.$apply(function () {
                            controller.windowFocus = false;
                        });
                    });

                    // Watch whether element is locked
                    // Note: Is locked iif the element has the locked class or element is the active element (if the window is focused)
                    $scope.$watch(function () {
                        return (attrs.locked && attrs.locked !== '' && $element.hasClass(attrs.locked)) || ($element[0] === $document[0].activeElement && controller.windowFocus);
                    }, function (value) {
                        controller.state = value ? 'locked' : 'initial';
                        controller.reloadBackground();
                    });
                }               
            }
        };
    }])
    /**
     * @ngdoc directive
     * @name hover.directive:syHoverItem
     * @description
     * Handles the registration of the hover item to the parent's items list.
     */
    // @ngInject
    .directive('syHoverItem', ['IconService', function (IconService) {
        return {
            scope: true,
            restrict: 'A',
            require: '^syHover',
            link: function ($scope, $element, attrs, controller) {
                // Check if there is an icon
                if (attrs.syHoverItem && attrs.syHoverItem !== '') {
                    $element.css('background-image', 'url("' + IconService.generateSVGUrl(attrs.syHoverItem, attrs.initial) + '")');

                    // Register the item if it has hover colours
                    if (attrs.hover1 && attrs.hover1 !== '') {
                        controller.items.push({
                            element: $element,
                            icon: attrs.syHoverItem,
                            initial: attrs.initial,
                            hover1: attrs.hover1,
                            hover2: attrs.hover2 && attrs.hover2 !== '' ? attrs.hover2 : attrs.hover1
                        });
                    }
                }
            }
        };
    }])
    /**
     * @ngdoc directive
     * @name hover.directive:syHoverBackground
     * @description
     * Handles the hover event of the attached element. When the element is hovered or
     * unhovered, any child elements that have the syHoverItem specified will change
     * their background image url and background colour.
     */
    // @ngInject
    .directive('syHoverBackground', ['$window', '$document', 'IconService', 'MobileService', function ($window, $document, IconService, MobileService) {
        return {
            scope: true,
            restrict: 'A',
            controller: [function () {
                var controller = this;

                // Initialise variables
                this.state = 'initial'; // Possible states are initial, hover and locked
                this.items = [];
                this.width = 0;
                this.windowFocus = true;

                // Reload the background image of all items
                this.reloadBackground = function () {
                    for (var i = 0; i < controller.items.length; i++) {
                        var item = controller.items[i];
                        if (item && item.element && item.icon && item.icon !== '') {
                            var iconColours = { icon: DEFAULT_ICON_COLOUR, background: DEFAULT_BACKGROUND_COLOUR };
                            switch (controller.state) {
                                case 'initial':
                                    iconColours = item.initial;
                                    break;
                                case 'hover':
                                case 'locked':
                                    if (controller.width < 610) {
                                        iconColours = item.hover1;
                                    }
                                    else {
                                        iconColours = item.hover2;
                                    }
                                    break;
                            }                            
                            item.element.css('background-image', 'url("' + IconService.generateSVGUrl(item.icon, iconColours.icon) + '")');
                            item.element.css('background-color', iconColours.background);
                        }
                    }
                };
            }],
            link: function ($scope, $element, attrs, controller) {
                controller.width = $window.innerWidth;
                
                // Set up the directive differently depending on if mobile or not
                if (MobileService.mobileCheck()) {
                    if (!MobileService.appleCheck()) {
                        $element.on('focus', function () {
                            controller.state = 'hover';
                            controller.reloadBackground();
                        });
                        $element.on('blur', function () {
                            controller.state = 'initial';
                            controller.reloadBackground();
                        });
                    }
                    else {
                        $element.on('touchstart', function () {
                            controller.state = 'hover';
                            controller.reloadBackground();
                        });
                        $element.on('touchend', function () {
                            controller.state = 'initial';
                            controller.reloadBackground();
                        });
                    }
                }
                else {
                    // Bind hover events
                    $element.on('mouseenter', function () {
                        if (controller.state !== 'locked') {
                            controller.state = 'hover';
                            controller.reloadBackground();
                        }
                    });
                    $element.on('mouseleave', function () {
                        if (controller.state !== 'locked') {
                            controller.state = 'initial';
                            controller.reloadBackground();
                        }
                    });

                    // Bind window events
                    angular.element($window).bind('resize', function () {
                        $scope.$apply(function () {
                            controller.width = $window.innerWidth;
                            controller.reloadBackground();
                        });
                    });
                    angular.element($window).bind('focus', function () {
                        $scope.$apply(function () {
                            controller.windowFocus = true;
                        });
                    });
                    angular.element($window).bind('blur', function () {
                        $scope.$apply(function () {
                            controller.windowFocus = false;
                        });
                    });

                    // Watch whether element is locked
                    // Note: Is locked iif the element has the locked class or element is the active element (if the window is focused)
                    $scope.$watch(function () {
                        return (attrs.locked && attrs.locked !== '' && $element.hasClass(attrs.locked)) || ($element[0] === $document[0].activeElement && controller.windowFocus);
                    }, function (value) {
                        controller.state = value ? 'locked' : 'initial';
                        controller.reloadBackground();
                    });
                }              
            }
        };
    }])
    /**
     * @ngdoc directive
     * @name hover.directive:syHoverBackgroundItem
     * @description
     * Handles the registration of the hover item to the parent's items list.
     */
    // @ngInject
    .directive('syHoverBackgroundItem', ['IconService', function (IconService) {
        return {
            scope: true,
            restrict: 'A',
            require: '^syHoverBackground',
            link: function ($scope, $element, attrs, controller) {
                // Check if there is an icon
                if (attrs.syHoverBackgroundItem && attrs.syHoverBackgroundItem !== '') {
                    $element.css('background-image', 'url("' + IconService.generateSVGUrl(attrs.syHoverBackgroundItem, attrs.initialColour) + '")');
                    $element.css('background-color', attrs.initialBackground);

                    // Register the item if it has hover colours
                    if (attrs.hover1Colour && attrs.hover1Colour !== '') {
                        controller.items.push({
                            element: $element,
                            icon: attrs.syHoverBackgroundItem,
                            initial: {
                                icon: attrs.initialColour,
                                background: attrs.initialBackground
                            },
                            hover1: {
                                icon: attrs.hover1Colour,
                                background: attrs.hover1Background
                            },
                            hover2: {
                                icon: attrs.hover2Colour && attrs.hover2Colour !== '' ? attrs.hover2Colour : attrs.hover1Colour,
                                background: attrs.hover2Background && attrs.hover2Background !== '' ? attrs.hover2Background : attrs.hover1Background,
                            }
                        });
                    }
                }
            }
        };
    }]);